var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { checkIfProfileComplete, getUser, } from './userHelper';
export var isFirstLogin = function (user) { return !user || !user.company; };
var getMarketoProfile = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, getUser(accessToken)];
}); }); };
var attemptProfileCompletion = function (userParam) { return __awaiter(void 0, void 0, void 0, function () {
    var user, marketoUser;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                user = __assign({}, userParam);
                return [4 /*yield*/, getMarketoProfile(user.accessToken)];
            case 1:
                marketoUser = _a.sent();
                if (!marketoUser || !marketoUser.company)
                    return [2 /*return*/, { success: false }];
                user.first_name = user.first_name || marketoUser.first_name;
                user.last_name = user.last_name || marketoUser.last_name;
                user.company = user.company || marketoUser.company;
                window.neo4jSandbox.tracking.event('SANDBOX_ONBOARDING_BYPASS_BY_MARKETO');
                return [2 /*return*/, { success: true, user: user }];
        }
    });
}); };
export var processUserObject = function (userParam) { return __awaiter(void 0, void 0, void 0, function () {
    var user, isMarketoSuccess, isProfileComplete, _a, success, completedProfile, isNetNew;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                user = __assign({ sub: userParam.sub }, userParam);
                isProfileComplete = checkIfProfileComplete(user);
                if (!!isProfileComplete) return [3 /*break*/, 2];
                return [4 /*yield*/, attemptProfileCompletion(user)];
            case 1:
                _a = _b.sent(), success = _a.success, completedProfile = _a.user;
                if (success && completedProfile.company) {
                    isMarketoSuccess = true;
                    user = __assign(__assign({}, user), completedProfile);
                }
                _b.label = 2;
            case 2:
                window.neo4jSandbox.tracking.setUserIdentity(user); // is a async function
                isNetNew = !isProfileComplete && !isMarketoSuccess;
                if (isNetNew && window.dataLayer) {
                    window.dataLayer.push({
                        netNew: true,
                        event: 'formFillSuccess',
                    });
                }
                return [2 /*return*/, { user: user, hasUpdated: isMarketoSuccess }];
        }
    });
}); };
